const NAMES_CORPORATE = [
  'ltda',
  'digital',
  'digitais',
  'treinamento',
  'marketing',
  'cursos',
  'negocios',
  'consultoria',
  ' e ',
  'empreendimentos',
  'comercio',
  'desenvolvimento',
  '-',
  'eventos',
  'mentoria',
  'agência',
  'educação',
  ' em ',
  'instituto',
  'academy',
  'soluções',
  '&',
  'negócios',
  'produtos'
]

const LIST_PUBLIC_EMAIL_PROVIDER = [
  'gmail',
  'hotmail',
  'msn',
  'outlook',
  'bol',
  'uol',
  'live',
  'yahoo',
  'icloud',
  'terra'
]

const LIST_WORDS_EMAIL_CORPORATE = [
  'ltda',
  'digita',
  'treinamento',
  'marketing',
  'curso',
  'negocios',
  'consultoria',
  'empreendimento',
  'comercio',
  'desenvolvimento',
  'evento',
  'mentoria',
  'agencia',
  'educacao',
  'instituto',
  'academy',
  'solucoes',
  '&',
  'negocio',
  'produto',
  'clinica',
  'centro',
  'hotmart',
  'contato',
  'vendas',
  'contact',
  'mkt',
  'suporte',
  'prof',
  'comercial',
  'adm',
  'assessoria',
  'empresa',
  'loja',
  'oficial',
  'suporte',
  'nutri',
  'atend',
  'lancamento',
  'afiliado',
  'grupo',
  'editora',
  'midia',
  'engenharia',
  'design',
  'template',
  'studio',
  'doce',
  'confeitaria',
  'yoga',
  'studio'
]

const verifyIfHasWord = (str, listStr) => {
  const regex = new RegExp(listStr.join('|'), 'i')

  return regex.test(str.toLowerCase())
}

function verifyPublicEmailProvider(email: string, wordList: string[]) {
  const domain = email.toLowerCase().split('@')[1].split('.')[0]

  return wordList.includes(domain)
}

export const isProxyCompany = ({ email, name }) => {
  const isPublicEmailProvider = verifyPublicEmailProvider(email, LIST_PUBLIC_EMAIL_PROVIDER)
  const isEmailEnterprise = verifyIfHasWord(email, LIST_WORDS_EMAIL_CORPORATE)
  const isNameEnterprise = verifyIfHasWord(name, NAMES_CORPORATE)

  return !isPublicEmailProvider || isEmailEnterprise || isNameEnterprise
}
